export default __webpack_public_path__ + "static/media/151-worker.ac6a0379.png";